import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";
import { MEDIA_URL } from '../../config/constants';

const CheckoutFooter = () => {
  const { t, getLocalizedPath, currentLanguage } = useTranslation('common');

  return (
    <footer className="checkout-footer">
      <div className="checkout-footer-top">
        <div className="checkout-footer-row">
          <div className="checkout-footer-campervan-info">
            <div className="checkout-footer-logo-section">
              <img
                src={`${MEDIA_URL}/images/sun_catchers_logo.png`}
                alt="Sun Catchers Logo"
                className="checkout-footer-logo"
                loading="lazy"
              />
            </div>
            <div className="checkout-footer-description">
              {t('footer.description')}
            </div>
          </div>

          <div className="checkout-footer-contact">
            <div className="checkout-footer-section-title">{t('footer.contact.title')}</div>
            <div className="checkout-footer-contact-details">
              <div className="checkout-footer-contact-item">
                <div className="checkout-footer-contact-icon">
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.25065 2.66675H13.2507C14.406 2.66675 15.3501 3.57105 15.4139 4.71047L15.4173 4.83341V11.1667C15.4173 12.3221 14.513 13.2662 13.3736 13.33L13.2507 13.3334H4.25065C3.0953 13.3334 2.15115 12.4291 2.08741 11.2897L2.08398 11.1667V4.83341C2.08398 3.67806 2.98828 2.73391 4.1277 2.67017L4.25065 2.66675ZM14.4173 6.24875L8.98352 9.10921C8.85858 9.17495 8.71272 9.18435 8.58185 9.13741L8.51778 9.10921L3.08398 6.24941V11.1667C3.08398 11.7789 3.55539 12.2809 4.15496 12.3295L4.25065 12.3334H13.2507C13.8628 12.3334 14.3648 11.862 14.4135 11.2624L14.4173 11.1667V6.24875ZM13.2507 3.66675H4.25065C3.63854 3.66675 3.13652 4.13815 3.08785 4.73773L3.08398 4.83341V5.11941L8.75065 8.10175L14.4173 5.11875V4.83341C14.4173 4.2213 13.9459 3.71929 13.3463 3.67061L13.2507 3.66675Z"
                      fill="#212121"
                    />
                  </svg>
                </div>
                <div className="checkout-footer-contact-text">
                  {t('footer.contact.email')}
                </div>
              </div>
              <div className="checkout-footer-contact-item">
                <div className="checkout-footer-contact-icon">
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.45333 1.61237L6.23133 1.37787C7.113 1.11211 8.05502 1.54159 8.43256 2.38148L9.03369 3.71863C9.35549 4.43451 9.18589 5.27585 8.61189 5.81115L7.61569 6.74015C7.58656 6.76728 7.56809 6.80395 7.56369 6.84355C7.53416 7.10828 7.71362 7.62388 8.12709 8.34008C8.42782 8.86095 8.69996 9.22615 8.93162 9.43161C9.09302 9.57475 9.18189 9.60568 9.21976 9.59441L10.56 9.18468C11.3104 8.95528 12.1236 9.22881 12.5827 9.86515L13.4365 11.0485C13.9739 11.7933 13.8773 12.8208 13.2104 13.4523L12.6195 14.0119C11.9819 14.6158 11.0742 14.8408 10.2284 14.6047C8.39229 14.0923 6.74608 12.5428 5.2715 9.98881C3.79487 7.43121 3.27674 5.22823 3.75438 3.38037C3.97296 2.53471 4.61704 1.86445 5.45333 1.61237ZM5.74193 2.56982C5.24016 2.72107 4.8537 3.12323 4.72256 3.63062C4.32079 5.18496 4.78003 7.13755 6.13753 9.48881C7.49322 11.8369 8.95249 13.2104 10.4972 13.6415C11.0047 13.7832 11.5493 13.6482 11.9319 13.2859L12.5228 12.7263C12.8259 12.4392 12.8698 11.9721 12.6256 11.6336L11.7718 10.4503C11.563 10.1611 11.1934 10.0367 10.8523 10.141L9.50876 10.5517C8.72896 10.7842 8.02116 10.1565 7.2611 8.84008C6.74889 7.95295 6.51016 7.26715 6.56988 6.73255C6.60081 6.45556 6.72986 6.19883 6.93367 6.00877L7.92989 5.0798C8.19082 4.83648 8.26789 4.45405 8.12162 4.12865L7.52049 2.79151C7.34887 2.40974 6.92068 2.21451 6.51993 2.33531L5.74193 2.56982Z"
                      fill="#212121"
                    />
                  </svg>
                </div>
                <div className="checkout-footer-contact-text">
                  {t('footer.contact.phone')}
                  <span className="contact-phone-note">{t('footer.contact.phoneNote')}</span>
                </div>
              </div>
              <div className="checkout-footer-contact-item">
                <div className="checkout-footer-contact-icon">
                  <svg
                    width="17"
                    height="24"
                    viewBox="0 0 17 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.14552 6.04542C6.41246 3.77848 10.0879 3.77848 12.3548 6.04542C14.6218 8.31236 14.6218 11.9878 12.3548 14.2548L11.5635 15.0374C10.9803 15.6098 10.2235 16.3458 9.29296 17.2454C8.71143 17.8077 7.7889 17.8076 7.2075 17.2453L4.8801 14.9814C4.58759 14.6942 4.34274 14.452 4.14552 14.2548C1.87858 11.9878 1.87858 8.31236 4.14552 6.04542ZM11.6477 6.75253C9.7713 4.87611 6.72904 4.87611 4.85262 6.75253C2.97621 8.62894 2.97621 11.6712 4.85262 13.5476L5.84401 14.526C6.38994 15.0602 7.07623 15.7272 7.9027 16.5265C8.0965 16.7139 8.40403 16.714 8.59783 16.5266L10.8611 14.3256C11.1738 14.0187 11.436 13.7594 11.6477 13.5476C13.5242 11.6712 13.5242 8.62894 11.6477 6.75253ZM8.25016 8.33252C9.3553 8.33252 10.2512 9.22841 10.2512 10.3336C10.2512 11.4387 9.3553 12.3346 8.25016 12.3346C7.14503 12.3346 6.24914 11.4387 6.24914 10.3336C6.24914 9.22841 7.14503 8.33252 8.25016 8.33252ZM8.25016 9.33252C7.6973 9.33252 7.24916 9.78069 7.24916 10.3336C7.24916 10.8864 7.6973 11.3346 8.25016 11.3346C8.80303 11.3346 9.25123 10.8864 9.25123 10.3336C9.25123 9.78069 8.80303 9.33252 8.25016 9.33252Z"
                      fill="#212121"
                    />
                  </svg>
                </div>
                <div className="checkout-footer-contact-text">
                  {t('footer.contact.address')}
                </div>
              </div>
            </div>
          </div>

          <div className="checkout-footer-quick-links">
            <div className="checkout-footer-section-title">{t('footer.quickLinks.title')}</div>
            <div className="checkout-footer-links-list">
              <Link to={getLocalizedPath("/")} className="checkout-footer-link">{t('footer.quickLinks.home')}</Link>
              <Link to={getLocalizedPath("/catalog")} className="checkout-footer-link">{t('footer.quickLinks.campervans')}</Link>
              <Link to={getLocalizedPath("/blog")} className="checkout-footer-link">{t('footer.quickLinks.vanTips')}</Link>
              <Link to={getLocalizedPath("/about")} className="checkout-footer-link">{t('footer.quickLinks.about')}</Link>
              <Link to={getLocalizedPath("/contact")} className="checkout-footer-link">{t('footer.quickLinks.contacts')}</Link>
            </div>
          </div>

          <div className="checkout-footer-help">
            <div className="checkout-footer-section-title">{t('footer.help.title')}</div>
            <div className="checkout-footer-links-list">
              <Link to={getLocalizedPath("/faq")} className="checkout-footer-link">{t('footer.help.faqs')}</Link>
              <div className="checkout-footer-link">{t('footer.help.support')}</div>
              <Link to={getLocalizedPath("/terms-and-conditions")} className="checkout-footer-link">{t('footer.help.termsAndConditions')}</Link>
              <Link to={getLocalizedPath("/privacy-policy")} className="checkout-footer-link">{t('footer.help.privacyPolicy')}</Link>
              <Link to={getLocalizedPath("/cookie-policy")} className="checkout-footer-link">{t('footer.help.cookiePolicy')}</Link>
              <a
                href="https://www.livroreclamacoes.pt/inicio"
                target="_blank"
                rel="noopener noreferrer"
                className="checkout-footer-link"
              >
                {t('footer.help.complaintsBook')}
              </a>
            </div>
          </div>

          <div className="checkout-footer-social">
            <a
              href="https://www.facebook.com/profile.php?id=61552285105121"
              target="_blank"
              rel="noopener noreferrer"
              className="checkout-footer-social-item"
              onClick={() => window.open('https://www.facebook.com/profile.php?id=61552285105121', '_blank')}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.4758 8.88546L11.8904 6.15536H9.2968V4.38449C9.2968 3.6374 9.65845 2.90876 10.8201 2.90876H12V0.58449C12 0.58449 10.9297 0.400024 9.90685 0.400024C7.76986 0.400024 6.37443 1.70789 6.37443 4.07459V6.15536H4V8.88546H6.37443V15.4857C6.85114 15.5613 7.33881 15.6 7.83562 15.6C8.33242 15.6 8.82009 15.5613 9.2968 15.4857V8.88546H11.4758Z" fill="white"/>
              </svg>
            </a>
            <a
              href="https://www.instagram.com/suncatchersportugal/"
              target="_blank"
              rel="noopener noreferrer"
              className="checkout-footer-social-item"
              onClick={() => window.open('https://www.instagram.com/suncatchersportugal/', '_blank')}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 1.44C10.136 1.44 10.39 1.448 11.232 1.488C12.032 1.524 12.466 1.654 12.754 1.762C13.136 1.906 13.408 2.078 13.694 2.364C13.98 2.65 14.152 2.922 14.296 3.304C14.404 3.592 14.534 4.026 14.57 4.826C14.61 5.668 14.618 5.922 14.618 8.058C14.618 10.194 14.61 10.448 14.57 11.29C14.534 12.09 14.404 12.524 14.296 12.812C14.152 13.194 13.98 13.466 13.694 13.752C13.408 14.038 13.136 14.21 12.754 14.354C12.466 14.462 12.032 14.592 11.232 14.628C10.39 14.668 10.136 14.676 8 14.676C5.864 14.676 5.61 14.668 4.768 14.628C3.968 14.592 3.534 14.462 3.246 14.354C2.864 14.21 2.592 14.038 2.306 13.752C2.02 13.466 1.848 13.194 1.704 12.812C1.596 12.524 1.466 12.09 1.43 11.29C1.39 10.448 1.382 10.194 1.382 8.058C1.382 5.922 1.39 5.668 1.43 4.826C1.466 4.026 1.596 3.592 1.704 3.304C1.848 2.922 2.02 2.65 2.306 2.364C2.592 2.078 2.864 1.906 3.246 1.762C3.534 1.654 3.968 1.524 4.768 1.488C5.61 1.448 5.864 1.44 8 1.44ZM8 0C5.828 0 5.556 0.01 4.702 0.05C3.85 0.09 3.27 0.224 2.76 0.42C2.232 0.624 1.788 0.898 1.346 1.34C0.904 1.782 0.63 2.226 0.426 2.754C0.23 3.264 0.096 3.844 0.056 4.696C0.016 5.55 0.006 5.822 0.006 7.994C0.006 10.166 0.016 10.438 0.056 11.292C0.096 12.144 0.23 12.724 0.426 13.234C0.63 13.762 0.904 14.206 1.346 14.648C1.788 15.09 2.232 15.364 2.76 15.568C3.27 15.764 3.85 15.898 4.702 15.938C5.556 15.978 5.828 15.988 8 15.988C10.172 15.988 10.444 15.978 11.298 15.938C12.15 15.898 12.73 15.764 13.24 15.568C13.768 15.364 14.212 15.09 14.654 14.648C15.096 14.206 15.37 13.762 15.574 13.234C15.77 12.724 15.904 12.144 15.944 11.292C15.984 10.438 15.994 10.166 15.994 7.994C15.994 5.822 15.984 5.55 15.944 4.696C15.904 3.844 15.77 3.264 15.574 2.754C15.37 2.226 15.096 1.782 14.654 1.34C14.212 0.898 13.768 0.624 13.24 0.42C12.73 0.224 12.15 0.09 11.298 0.05C10.444 0.01 10.172 0 8 0Z" fill="white"/>
                <path d="M8 3.89C5.732 3.89 3.894 5.728 3.894 7.996C3.894 10.264 5.732 12.102 8 12.102C10.268 12.102 12.106 10.264 12.106 7.996C12.106 5.728 10.268 3.89 8 3.89ZM8 10.662C6.528 10.662 5.334 9.468 5.334 7.996C5.334 6.524 6.528 5.33 8 5.33C9.472 5.33 10.666 6.524 10.666 7.996C10.666 9.468 9.472 10.662 8 10.662Z" fill="white"/>
                <path d="M12.27 4.69C12.8 4.69 13.23 4.26 13.23 3.73C13.23 3.2 12.8 2.77 12.27 2.77C11.74 2.77 11.31 3.2 11.31 3.73C11.31 4.26 11.74 4.69 12.27 4.69Z" fill="white"/>
              </svg>
            </a>
            <a
              href="https://m.youtube.com/channel/UCX0YV3EpxFWP6VwnO47BMBQ"
              target="_blank"
              rel="noopener noreferrer"
              className="checkout-footer-social-item"
              onClick={() => window.open('https://m.youtube.com/channel/UCX0YV3EpxFWP6VwnO47BMBQ', '_blank')}
            >
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.6704 4.81953C15.4859 4.13419 14.9456 3.59383 14.2602 3.40932C13.0082 3.06665 7.99997 3.06665 7.99997 3.06665C7.99997 3.06665 2.99175 3.06665 1.7397 3.39614C1.06754 3.58065 0.514001 4.13419 0.329488 4.81953C0 6.07158 0 8.66794 0 8.66794C0 8.66794 0 11.2775 0.329488 12.5164C0.514001 13.2017 1.05436 13.7421 1.7397 13.9266C3.00493 14.2692 7.99997 14.2692 7.99997 14.2692C7.99997 14.2692 13.0082 14.2692 14.2602 13.9397C14.9456 13.7552 15.4859 13.2149 15.6704 12.5295C15.9999 11.2775 15.9999 8.68112 15.9999 8.68112C15.9999 8.68112 16.0131 6.07158 15.6704 4.81953Z" fill="white"/>
                <path d="M6.4043 11.0666L10.569 8.66796L6.4043 6.26929V11.0666Z" fill="#380C01"/>
              </svg>
            </a>
            <a
              href="https://www.tiktok.com/@sun.catchers.portugal"
              target="_blank"
              rel="noopener noreferrer"
              className="checkout-footer-social-item"
              onClick={() => window.open('https://www.tiktok.com/@sun.catchers.portugal', '_blank')}
            >
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.4927 0.333374H8.73041V11.2319C8.73041 12.5305 7.66803 13.5972 6.34593 13.5972C5.02384 13.5972 3.96145 12.5305 3.96145 11.2319C3.96145 9.95657 5.00023 8.91306 6.27512 8.86671V6.13049C3.46566 6.17684 1.19922 8.42613 1.19922 11.2319C1.19922 14.0609 3.51288 16.3334 6.36955 16.3334C9.22619 16.3334 11.5398 14.0377 11.5398 11.2319V5.64351C12.5786 6.38555 13.8535 6.82613 15.1992 6.84933V4.11309C13.1217 4.04352 11.4927 2.37395 11.4927 0.333374Z" fill="white"/>
              </svg>
            </a>
          </div>
        </div>
        <div className="checkout-footer-divider"></div>
      </div>

      <div className="checkout-footer-bottom">
        <div className="checkout-footer-language-selector">
          <div className="checkout-footer-language-icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_325_5312)">
                <path
                  d="M1.16602 6.99996H12.8327M1.16602 6.99996C1.16602 10.2216 3.77769 12.8333 6.99935 12.8333M1.16602 6.99996C1.16602 3.7783 3.77769 1.16663 6.99935 1.16663M12.8327 6.99996C12.8327 10.2216 10.221 12.8333 6.99935 12.8333M12.8327 6.99996C12.8327 3.7783 10.221 1.16663 6.99935 1.16663M6.99935 1.16663C8.45843 2.764 9.28762 4.83698 9.33268 6.99996C9.28762 9.16294 8.45843 11.2359 6.99935 12.8333M6.99935 1.16663C5.54027 2.764 4.71108 4.83698 4.66602 6.99996C4.71108 9.16294 5.54027 11.2359 6.99935 12.8333"
                  stroke="#070707"
                  strokeWidth="1.3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_325_5312">
                  <rect width="14" height="14" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="checkout-footer-language-text">{currentLanguage.toUpperCase()}</div>
          <div className="checkout-footer-language-dropdown">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 5.25L7 8.75L10.5 5.25"
                stroke="#070707"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className="checkout-footer-copyright">
          {t('footer.copyright')}
        </div>
        <div className="checkout-footer-privacy">
          <Link to={getLocalizedPath("/terms-and-conditions")} className="checkout-footer-privacy-link">{t('footer.help.termsAndConditions')}</Link>
          <span> • </span>
          <Link to={getLocalizedPath("/privacy-policy")} className="checkout-footer-privacy-link">{t('footer.help.privacyPolicy')}</Link>
          <span> • </span>
          <Link to={getLocalizedPath("/cookie-policy")} className="checkout-footer-privacy-link">{t('footer.help.cookiePolicy')}</Link>
        </div>
      </div>
    </footer>
  );
};

export default CheckoutFooter;
